import { render } from "./VerifyIdentityFileForm.vue?vue&type=template&id=21b16ff8"
import script from "./VerifyIdentityFileForm.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityFileForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/fishing-license/fishing-license-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__